import Api from '../Api';

import { url } from './config';
import { EventType } from './types';

const api = new Api<EventType>(url);

export default api;
